import React from 'react';
import Navbar from "../components/Navbar/Navbar";
import Section404 from "../components/Section404/Section404";

const _404 = () => {
  return (
    <>
      <Navbar />
      <Section404 />
    </>
  );
};

export default _404;